// extracted by mini-css-extract-plugin
export default {"Box":"User_Box__6hJAM","UserBox":"User_UserBox__yj3dC","BoxInnerHeader":"User_BoxInnerHeader__HAuMn","BoxHeader":"User_BoxHeader__KSwNw"};